import { Spin } from "antd";
import React from "react";
import styles from "./index.module.less";

export default function FullscreenLoading() {
  return (
    <div className={styles.container}>
      <Spin size="large" />
    </div>
  );
}
